import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Text } from '@chakra-ui/react'

import { OrderItemInfo } from 'appTypes/orders'
import { ItemCard } from 'components/ui/ItemCard'

type Props = {
  complementaryItemsInfo: OrderItemInfo[] | undefined
}

export const StaticComplementaryItems: React.FC<Props> = ({ complementaryItemsInfo }) => {
  const { t } = useTranslation('common')

  return (
    <Box width="100%">
      <Text marginBottom="12px" fontSize="xs">
        {t('accessories')}
      </Text>
      {complementaryItemsInfo?.map((orderItemInfo) => (
        <ItemCard
          key={orderItemInfo.orderItem.id}
          orderItemInfo={orderItemInfo}
          imageWidth={{ base: 88, md: 108 }}
          imageHeight={{ base: 88, md: 108 }}
          marginBottom="20px"
        />
      ))}
    </Box>
  )
}
